import { Component, Input, OnInit } from '@angular/core';
import { NavigationHistoryService } from '../../services/navigation-history.service';

/**
 * Reusable navigation back button component
 * Automatically retrieves the appropriate return label and handles navigation
 * based on the NavigationHistoryService's smart fallback logic
 */
@Component({
    selector: 'edl-navigation-back-button',
    templateUrl: './navigation-back-button.component.html',
    styleUrls: ['./navigation-back-button.component.scss']
})
export class NavigationBackButtonComponent implements OnInit {
    /** Additional CSS classes to apply to the button */
    @Input() buttonClass = 'btn btn-cancel ms-2 d-flex align-items-center filter-btn-height';

    /** Icon CSS classes (default is left arrow) */
    @Input() iconClass = 'fas fa-arrow-left me-1';
    @Input() showIcon = true;

    /** Custom aria-label (if not provided, uses the return label) */
    @Input() ariaLabel?: string;

    returnLabel: string;

    constructor(private navigationHistory: NavigationHistoryService) {}

    ngOnInit() {
        this.returnLabel = this.navigationHistory.getReturnLabel();
    }

    onNavigateBack() {
        this.navigationHistory.goToLastEntryPoint();
    }
}
